export const isLocalStorageAvailable = (): boolean => {
  try {
    localStorage.setItem('GAMIPHY_TEST', 'GAMIPHY_TEST');
    localStorage.removeItem('GAMIPHY_TEST');
    return true;
  } catch {
    return false;
  }
};

export const setLocalStorageItem = (key: string, item: string): void => {
  if (isLocalStorageAvailable()) {
    localStorage.setItem(key, item);
  }
};

export const getLocalStorageItem = (key: string): string | null => {
  if (isLocalStorageAvailable()) {
    return localStorage.getItem(key);
  }
  return null;
};

export const removeLocalStorageItem = (key: string): void => {
  if (isLocalStorageAvailable()) {
    localStorage.removeItem(key);
  }
};

export const clearLocalStorage = (): void => {
  if (isLocalStorageAvailable()) {
    localStorage.clear();
  }
};
